<template>
	<common-tooltip trigger="click" :tooltip="tooltipText" :force-show="showCopyTooltip" :icon="false">
		<a
			href="#"
			@click.prevent="copyValue"
			@mouseover="showCopyTooltip = true"
			@mouseleave="showCopyTooltip = false"
		>
			<slot />
		</a>
	</common-tooltip>
</template>

<script lang="js">
import { copy } from '@/components/mixins/copy';

export default {
	mixins: [copy],
};
</script>
